module.exports = __webpack_public_path__ + "static/media/viberLogoMob.65b0af55.svg";